import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SignUp } from '@clerk/clerk-react';
import { Box, Typography, Container } from '@mui/material';

function SignUpPage() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      }}
    >
      <Helmet>
        <title>Εγγραφή | Majestify</title>
        <meta name="description" content="Δημιούργησε δωρεάν λογαριασμό στο Majestify για διαχείριση επιχείρησης, προσωπικού και οικονομικών." />
      </Helmet>
      <Container maxWidth="sm">
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography variant="h3" sx={{ color: 'white', fontWeight: 'bold', mb: 1 }}>
            🌴 Palmera
          </Typography>
          <Typography variant="h6" sx={{ color: 'rgba(255,255,255,0.8)' }}>
            Δημιουργία Λογαριασμού
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <SignUp 
            routing="path" 
            path="/sign-up"
            signInUrl="/sign-in"
            afterSignUpUrl="/"
          />
        </Box>
      </Container>
    </Box>
  );
}

export default SignUpPage;

